import { Link, Outlet, useParams, useRouterState } from '@tanstack/react-router';

const tabs = [
  { to: '/workspaces/$id' as const, label: 'Overview' },
  { to: '/workspaces/$id/services' as const, label: 'Services' },
  { to: '/workspaces/$id/insights' as const, label: 'Insights' },
  { to: '/workspaces/$id/ai-visibility' as const, label: 'AI Visibility' },
  { to: '/workspaces/$id/operations' as const, label: 'Operations' },
  { to: '/workspaces/$id/logs' as const, label: 'Logs' },
  { to: '/workspaces/$id/billing' as const, label: 'Billing' },
  { to: '/workspaces/$id/team' as const, label: 'Team' },
  { to: '/workspaces/$id/settings' as const, label: 'Settings' },
];

export function WorkspaceLayout() {
  const { id } = useParams({ strict: false }) as { id: string };
  const path = useRouterState({ select: (s) => s.location.pathname });

  return (
    <div className="mx-auto max-w-7xl px-6 py-8">
      <header className="mb-4">
        <Link to="/workspaces" className="text-xs text-slate-500 hover:text-slate-700">
          ← Workspaces
        </Link>
        <h1 className="text-2xl font-semibold mt-1">{id}</h1>
      </header>
      <nav className="mb-6 flex flex-wrap gap-1 border-b border-slate-200">
        {tabs.map((t) => {
          const full =
            t.to === '/workspaces/$id' ? `/workspaces/${id}` : t.to.replace('$id', id);
          const active = path === full;
          return (
            <Link
              key={t.label}
              to={t.to}
              params={{ id }}
              className={`px-4 py-2 text-sm border-b-2 -mb-px transition ${
                active
                  ? 'border-brand-600 text-brand-700'
                  : 'border-transparent text-slate-600 hover:text-brand-700'
              }`}
            >
              {t.label}
            </Link>
          );
        })}
      </nav>
      <Outlet />
    </div>
  );
}
